import windowIdMixin from './window-id'
import { windowTitleProp } from '../utils'

export default {
  mixins: [windowIdMixin],
  computed: {
    windowTitle: windowTitleProp()
  }
}



// WEBPACK FOOTER //
// ./src/mixins/window-props.js